var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-event-form',{attrs:{"limitedCapability":_vm.hasSubscriber}})
}
var staticRenderFns = []

export { render, staticRenderFns }